/**
 * riskreducer.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {isApiResponseOk} from '../../util/utils';
import {HttpStatusCodes, RiskTypes} from '../../util/uiconstants';

export function risksReducer(state = initialstate.risks, action) {
	const deleteRiskFromState = (riskId) => {
		let tempState = _.cloneDeep(state);
		tempState.data = tempState?.data?.filter((risk) => risk.id !== Number(riskId));
		return tempState;
	};
	switch (action.type) {
		case types.GET_RISKS:
		case types.GET_RISKS_With_ACCOUNTS_ASSERTIONS:
			if (action.response && action.response.data) {
				return action.response;
			}
			return state;
		case types.GET_RISK_BY_ID:
			if (isApiResponseOk(action)) {
				return {
					...state,
					selectedRisk: action.response
				};
			} else if (action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromState(action.riskId); // If the Risk is not found, remove it from the list (concurrency scenario)
			}
			return state;

		case types.DELETE_RISK:
			if (isApiResponseOk(action) || action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromState(action.riskId);
			}
			return state;
		case types.UPDATE_RISK:
			if (!_.isEmpty(action.response)) {
				let newState = _.cloneDeep(state);
				const editIndex = newState?.data?.findIndex((x) => x.id === action.response.id);
				newState.data[editIndex] = {...action.response, isCallingGetApi: true};
				return newState;
			} else if (action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromState(action?.meta?.api?.data?.id); // If the Risk is not found, remove it from the list (concurrency scenario)
			}

			return state;
		case types.CREATE_ASSERTION_RISK_RELATION:
			if (action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromState(action?.risk.id); // If the Risk is not found, remove it from the list (concurrency scenario)
			}
		case types.GET_RISK_BY_ID_WITH_ACCOUNTS_ASSERTIONS:
			if (!_.isEmpty(action.response)) {
				let newState = _.cloneDeep(state);
				const editIndex = newState?.data?.findIndex((x) => x.id === action.response.id);
				newState.data[editIndex] = {...action.response, isCallingGetApi: false};
				return newState;
			}

			return state;

		case types.CREATE_RISK:
			if (isApiResponseOk(action)) {
				let newState;

				if (Object.keys(state).length === 0) {
					newState = {
						data: [action.response]
					};
				} else {
					newState = _.cloneDeep(state);
					newState.data = [..._.cloneDeep(state.data), action.response];
				}
				newState.selectedRisk = action.response;
				return newState;
			}
			return state;
		case types.CLEAR_RISK:
			return {
				...state,
				selectedRisk: null
			};
		default:
			return state;
	}
}

export function wcgwRelatedRisksReducer(state = initialstate.wcgwRelatedRisks, action) {
	switch (action.type) {
		case types.GET_RISKS_FOR_WCGWID:
			return action.response && action.response.value
				? action.response.value
				: action.response.data !== undefined
				? action.response
				: state;

		default:
			return state;
	}
}

export function relatedRisksReducer(state = initialstate.wcgwRelatedRisks, action) {
	switch (action.type) {
		case types.GET_RELATED_RISKS_FOR_WCGWID:
			return action.response && action.response.value
				? action.response.value
				: action.response.data !== undefined
				? action.response
				: state;
		default:
			return state;
	}
}

export function riskListReducer(state = initialstate.riskList, action) {
	let riskList = _.cloneDeep(state.data);
	switch (action.type) {
		case types.GET_RISK_LIST:
			if (action.response && action.response.data) {
				let formatedRisks = formatRiskListForProcedureAndTocCount(action.response.data);

				return {...state, data: formatedRisks};
			}
			return state;
		case types.GET_RISK_LIST_WITH_NO_SUBSTANTIVE_COUNT:
			if (action.response && action.response.data) {
				let risksWithNoSubstantive = formatRiskListForProcedureAndTocCount(action.response.data);
				const risksWithNoSubstantiveProcedure = risksWithNoSubstantive?.filter(
					(val) => val.riskTypeId === RiskTypes.Significant || val.riskTypeId === RiskTypes.Fraud
				);
				return {
					...state,
					risksWithNoSubstantiveProcedure
				};
			}
			return state;
		case types.GET_RISKS_With_ACCOUNTS_ASSERTIONS:
			if (action.response && action.response.data) {
				return action.response;
			}
			return state;
		case types.GET_RESPONSIVE_TASKS_CONTROLS_BY_RISKID:
			if (action.response) {
				let riskIndex = riskList.findIndex((risk) => risk.id === action.response.id);
				if (riskIndex !== -1) {
					riskList[riskIndex].responsiveTasks = formatTasksAndControls(action.response.responsiveTasks);
					let assertionIds = riskList[riskIndex].assertions.map((assertion) => assertion.id);
					riskList[riskIndex].proceduresCount = _.uniqBy(
						action.response.responsiveTasks
							?.filter((task) => assertionIds.includes(task.assertionId))
							.flatMap((x) => x.assertionTasks),
						'taskId'
					).length;
					riskList[riskIndex].tocCount = _.uniqBy(
						action.response.responsiveTasks
							?.filter((task) => assertionIds.includes(task.assertionId))
							.flatMap((x) => x.controls.flatMap((c) => c.controlTasks)),
						'taskId'
					).length;
					return {...state, data: riskList};
				}
				return {...state, data: riskList};
			}
			return state;
		default:
			return state;
	}
}

// Add procedures and TOC count to riskList
export function formatRiskListForProcedureAndTocCount(risks) {
	risks?.forEach((risk) => {
		risk.proceduresCount = [...(new Set(risk?.procedureTasks?.map((task) => task)) ?? [])].length;
		risk.tocCount = [...(new Set(risk?.controlTasks?.map((task) => task)) ?? [])].length;
		if (risk.responsiveTasks) {
			risk.responsiveTasks = formatTasksAndControls(risk.responsiveTasks);
		}
	});
	return risks;
}
/*
 Group Risks by Risk Types
 */
export function groupRisksByRiskTypes(risks) {
	let risksGroupedByRiskTypes = {};
	if (risks && risks.data && risks.data.length > 0) {
		risksGroupedByRiskTypes = _.chain(risks.data)
			// Group the elements of Array based on `risk type id` property
			.groupBy('riskTypeId')
			// `key` is group's name (risk type id), `value` is the array of objects (risks)
			.map((value, key) => ({riskTypeId: key, risks: value}))
			.value();
	}
	return risksGroupedByRiskTypes;
}

export function formatRisks(risks) {
	let formattedRisks = [];
	if (risks?.length > 0) {
		formattedRisks = [...risks];
	}

	return formattedRisks;
}

const formatTasksAndControls = (responsiveTasks) => {
	let responseTasksandControls = [];
	for (let task of responsiveTasks) {
		//format responsive tasks
		if (task.assertionTasks) {
			task.assertionTasks = task.assertionTasks.map((task) => {
				return {...task, id: task.taskId};
			});
		}
		//format control tasks
		if (task.controls && task.controls.length > 0) {
			for (let control of task.controls) {
				if (control?.controlTasks) {
					control.controlTasks = control.controlTasks.map((task) => {
						return {...task, id: task.taskId};
					});
				}
			}
		}
		responseTasksandControls.push(task);
	}
	return responseTasksandControls;
};
